import { postRequest } from "./api";
import { API_URL } from "./Environment";

export const ticketRaisedAPI = async(payload) => {
    return postRequest(`${API_URL}chat/get-complaints`,payload)
       .then((resp) => (resp));
 }